import {
  Directive, OnInit, OnChanges, OnDestroy, SimpleChanges, Input, Injector, NgZone,
} from '@angular/core';
import { of, Subscription } from 'rxjs';
import {
  BindingData, BindingList, ViewModel, DataTypeInfo, DataPropInfo, ENABLE_EDIT_STATE_FILTER_SORTING
} from '@farris/devkit';
import { DatagridComponent } from '@farris/ui-datagrid';
import { isNumber } from 'lodash-es';
import { DateTimeHelperService } from '@farris/ui-common/date';
import { RuntimeStateService } from '@farris/ui-common';
import { DialogService } from '@farris/ui-dialog';
import { LookupGridComponent } from '@farris/ui-lookup';
import { ComboLookupComponent } from '@farris/ui-combo-lookup';

@Directive({
  selector: '[farris-datagrid-editable]'
})
export class EditableDirective implements OnInit, OnChanges, OnDestroy {
  /**
   * gridæ¯å¦å¯ä»¥ç¼è¾
   */
  @Input('farris-datagrid-editable') gridEditable: boolean;
  /**
   * ç¼è¾æ¶åæ¶åç»
   */
  @Input('disableGroupOnEditing') disableGroupOnEditing: boolean = true;
  /**
   * å¤éå¸®å©é»è®¤åéç¬¦
   */
  private defaultSpliter: string = ',';
  private beginEditSubscription: Subscription;
  private endEditSubscription: Subscription;
  /**
   * ä¸´æ¶è®°å½gridåç»å­æ®µ
   */
  private groupFields: any[] = [];
  protected get bindingList(): BindingList {
    // æ ¹å®ä½
    if (this.viewModel.bindingPath === '/' || !this.viewModel.bindingPath) {
      return this.bindingData.list;
    }
    // å­å®ä½
    let bindingPath = this.viewModel.bindingPath.substr(1);
    bindingPath = bindingPath[0].toLowerCase() + bindingPath.substring(1, bindingPath.length);
    const paths = bindingPath.split('/');

    const filteredPaths = paths.filter((part: string) => {
      return part !== '';
    });
    return this.bindingData.getValue(filteredPaths);
  }
  constructor(
    public bindingData: BindingData,
    public viewModel: ViewModel,
    public grid: DatagridComponent,
    private dateService: DateTimeHelperService,
    public injector: Injector,
    private rts: RuntimeStateService,
    public dialogSer: DialogService,
    public ngZone: NgZone
  ) { }

  ngOnInit() {
    this.apply();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.apply();
  }
  ngOnDestroy() {
    this.detach();
  }
  /**
   * åºç¨å±æ§
   */
  private apply() {
    if (!this.grid) {
      return;
    }
    this.handleGroupStatus();
    // æ¯å¦å¯ç¨äºç¼è¾æè¿æ»¤æåº
    if (this.gridEditable) {
      const enableFilterSorting = this.injector && this.injector.get<boolean>(ENABLE_EDIT_STATE_FILTER_SORTING, false) || false;
      if (!this.grid.remoteFilter && !enableFilterSorting) {
        this.grid.clearCondition();
        // åéæ¸ç©ºè¿æ»¤æ¡ä»¶äºä»¶
        this.viewModel.frameContext.appContext.messagePipe.next('CLEAR_GRID_CONDITION');
      }

      this.grid.editable = true;
      if (!this.viewModel.frameContext.appContext.enableGridHeaderWhenEditing && !enableFilterSorting) {
        this.grid.disableHeader(true);
      }
      this.handleBeginEditEvent();
      this.handleAfterEditEvent();
      this.handleEndEditEvent();
    } else {
      this.grid.editable = false;
      this.grid.disableHeader(false);
      // TODO:åºç±è¡¨æ ¼å¼å®¹ï¼ä½ç®åè¡¥ä¸ä¸è½ç»§ç»­ä¾èµè¡¨æ ¼ç»ä»¶ï¼ä¸´æ¶ä½¿ç¨è¯¥æ¹æ¡å¤ç
      // 2023-12-25 è¡¨æ ¼åé¨å·²è§£å³åè®¾ç½®åè¡¨å¤´æ æ³æå¨é®é¢ï¼ä¸å¼å®¹ä»£ç å­å¨è¦çå¼åèè®¾ç½®çèªå®ä¹ååç§°çé®é¢
      // this.grid.columns = this.grid.columns.map((cols) => {
      //   return cols.map((col) => Object.assign({}, col));
      // });
      // this.grid.columnsChanged(false);
      if (this.grid && typeof this.grid.sort === 'function' && this.grid.sortName) {
        this.grid.sort();
      }
      this.detach();
    }
  }
  /**
   * ç¼è¾æ¶åæ¶åç»
   */
  private handleGroupStatus() {
    if (this.disableGroupOnEditing === false) {
      return;
    }
    const groupField = this.grid && this.grid.groupField || null;
    if (groupField) {
      if (this.gridEditable) {
        this.groupFields = [groupField];
        this.grid.setGroupFields('');
      }
    } else {
      if (this.groupFields && this.groupFields.length > 0) {
        const groupField = this.groupFields.pop();
        if (this.groupFields.length > 0) {
          this.groupFields = [];
        }
        this.grid.setGroupFields(groupField);
      }
    }
  }
  /**
   * å¤çå¼å§ç¼è¾äºä»¶
   */
  private handleBeginEditEvent() {
    this.beginEditSubscription = this.grid.beginEdit.subscribe((e: any) => {
      if (!e) {
        return;
      }
      const column = e.column;
      if (column && column.editor) {
        const editorInstance = e.editor.componentRef.instance;
        if (!editorInstance || !editorInstance.instance) {
          return;
        }
        let mapFields = editorInstance.instance.mapFields;
        if (['lookup', 'PersonnelSelector', 'OrganizationSelector', 'external-integration', 'EmployeeSelector', 'EmployeeOrgSelector', 'lookup-light'].includes(column.editor.type)) {
          const lookupGrid: LookupGridComponent = editorInstance.instance;
          const subject = editorInstance.instance.selectedData;
          if (subject) {
            subject.subscribe((data: any) => {
              mapFields = editorInstance.instance.mapFields;
              const spliter = lookupGrid.multipleChoiceSeparator || this.defaultSpliter;
              this.lookupMapping(data, mapFields, false, spliter);
            });
          }
          const clearMappings = editorInstance.instance.clearMappings;
          if (clearMappings) {
            clearMappings.subscribe((result: any) => {
              const mapFields = Object.assign({}, editorInstance.instance.mapFields);
              const value = result && result.value || null;
              const binding = editorInstance.column && editorInstance.column.field;
              const lookupTextField = editorInstance.instance.textField;
              const data = {};
              if (binding) {
                const textFieldMapping = mapFields[lookupTextField];
                if (textFieldMapping) {
                  const otherField: string = textFieldMapping.split(',').filter((item) => item !== binding).join(',');
                  if (otherField) {
                    mapFields[lookupTextField] = otherField;
                  } else {
                    delete mapFields[lookupTextField];
                  }
                }
                const parentPaths = this.getBindingPathArray();
                this.bindingData.setValue(parentPaths.concat(binding.split('.')), value, true, true);
              }
              // this.setValue(data, lookupTextField.split('.'), value);
              if (mapFields && Object.keys(mapFields).length > 0) {
                Object.keys(mapFields).forEach((field) => {
                  this.setValue(data, field.split('.'), '');
                });
                this.lookupMapping(data, mapFields, true);
              }
            });
          }
        }

        if (column.editor.type === 'combo-lookup') {
          editorInstance.instance.valueChange.subscribe((e: any) => {
            const nosearch = e.nosearch || false;
            mapFields = editorInstance.instance.mapFields;
            if (nosearch) {
              // ä»»æè¾å¥åºæ¯
              const lookupTextField = editorInstance.instance.textField;
              const binding = editorInstance.column && editorInstance.column.field;
              this.onClearMapping(mapFields, lookupTextField, binding);
            } else {
              const asClear = e && e.selections && e.selections.length === 0;
              const data = e.selections && e.selections.length > 0 ? e.selections : null;
              const comboLookup: ComboLookupComponent = editorInstance.instance;
              const spliter = comboLookup.separator || this.defaultSpliter;
              this.lookupMapping(data, mapFields, asClear, spliter);
            }
          });
        }
        if (['combo-lookup', 'lookup-light', 'combolist', 'lookup', 'PersonnelSelector', 'OrganizationSelector', 'external-integration', 'EmployeeSelector', 'EmployeeOrgSelector'].includes(column.editor.type)) {
          if (editorInstance.instance.clear && editorInstance.instance.clear.subscribe) {
            editorInstance.instance.clear.subscribe(() => {
              this.lookupMapping(null, mapFields);
            });
          }
        }

        if (column.editor.type === 'combolist') {
          if (mapFields) {
            editorInstance.instance.valueChange.subscribe((e) => {
              const pathArr = this.getBindingPathArray();
              this.viewModel.bindingData.setValue(pathArr.concat(mapFields.split('.')), editorInstance.instance.selectedValues, true, true);
            });
          }
        }
      }
    });
  }
  private onClearMapping(mapfields: any, textField: string, binding: string) {
    const data = {};
    const textFieldMapping = mapfields[textField];
    if (textFieldMapping) {
      const targetField = textFieldMapping.split(',').filter((item) => item !== binding).join(',');
      if (targetField) {
        mapfields[textField] = targetField;
      } else {
        delete mapfields[textField];
      }
    }
    if (mapfields && Object.keys(mapfields).length > 0) {
      Object.keys(mapfields).forEach((field) => {
        this.setValue(data, field.split('.'), '');
      });
      this.lookupMapping(data, mapfields, true);
    }
  }
  /**
   * å¤çç¼è¾äºä»¶
   */
  private handleAfterEditEvent() {
    this.grid.afterEdit = (rowIndex, rowData, column, editor) => {
      if (this.dialogSer.hasDialogOpened()) {
        if (column && column.editor.type === 'lookup' && this.viewModel.frameContext.appContext.params.get('FORCE_END_EDIT') === true) {
          return of(true);
        }
        return of(false);
      }
      if (this.rts) {
        // å¸®å©ç»ä»¶ææ¬åååå»æ¥è¯¢
        if (this.rts.getFormState('lookup.pending')) {
          return of(false);
        }
      }
      // æ´æ°æ°æ®æº
      if (!editor || !editor.formControl) {
        return of(false);
      }
      return of(true);
    };
  }
  /**
   * å¤çç»æç¼è¾äºä»¶
   */
  private handleEndEditEvent() {
    this.endEditSubscription = this.grid && this.grid.endEdit && this.grid.endEdit.subscribe((event: any) => {
      const { value = undefined, column = undefined, rowData = {} } = event || {};
      const primaryValue = rowData && rowData[this.grid.idField] || null;
      this.updateBindingData(value, column, primaryValue);
    });
  }
  /*
   * ç»åè¡¨èµå¼ æç»formcontrolèµå¼
   */
  private updateBindingData(value: any, column: any, primaryValue?: any) {
    if (!column) {
      return;
    }
    const currentColumnType = column.dataType;
    // åæ¶å¤æ­gridOptionçåå¯¹è±¡

    const fieldPaths = column.field.split('.');
    // æ¯å¦ä¸ºå¤§æ°
    const isBigNumber = column && column.editor && column.editor.options && column.editor.options.bigNumber;
    // å­å¨è¡ç¼è¾å¨
    if (currentColumnType === 'date') {
      let result;
      if (value) {
        result = this.dateService.formatTo(value, 'yyyy-MM-dd');
      } else {
        result = value;
      }
      this.updateBindingList(primaryValue, fieldPaths.join('.'), result);
    } else if (currentColumnType === 'datetime') {
      // if (!value) {
      //   value = '0001-01-01T00:00:00';
      // }
      this.updateBindingList(primaryValue, fieldPaths.join('.'), value);
    } else if (currentColumnType === 'number' && !isBigNumber) {
      if (value === null || value === undefined) {
        this.updateBindingList(primaryValue, fieldPaths.join('.'), null);
      } else {
        this.updateBindingList(primaryValue, fieldPaths.join('.'), Number(value));
      }
    } else {
      this.updateBindingList(primaryValue, fieldPaths.join('.'), value);
    }
  }
  private updateBindingList(primaryValue: any, propertyName: string, value: any) {
    const viewModel = this.viewModel || null;
    if (!viewModel || !propertyName) {
      return;
    }
    // æ´æ°ä¸»è¡¨é¨åè¡çå­æ®µ
    const propertyNames = propertyName.split('.').filter((item) => item);
    const bindingPath = this.getBindingPathArray();
    // ååºæ¥çä¸å®æ¯bindingList
    const list = this.bindingData.getValue(bindingPath) as BindingList;
    // ä¿®æ¹çæ¯å½åè¡
    if (list && primaryValue === list.currentItem.primaryKeyValue) {
      const paths = bindingPath.concat(propertyNames);
      this.bindingData.setValue(paths, value, true, true, null, { frameContext: this.viewModel.frameContext });
      return;
    }
    const bindingObject = this.bindingList.findById(primaryValue);
    if (!bindingObject) {
      return;
    }
    if (propertyNames.length < 2) {
      bindingObject.setValue(propertyName, value, true, true);
    } else {
      let targetBindingObject = null;
      const fpaths = propertyNames.slice(0, propertyNames.length - 1);
      const targetPropertyName = propertyNames[propertyNames.length - 1];
      fpaths.forEach((prop) => {
        targetBindingObject = targetBindingObject && targetBindingObject[prop] || bindingObject[prop];
      });
      // todo:éè¦æ·»å å¼ååäºä»¶
      targetBindingObject.setValue(targetPropertyName, value, true, true);
    }
  }
  private detach() {
    if (this.beginEditSubscription && typeof this.beginEditSubscription.unsubscribe === 'function') {
      this.beginEditSubscription.unsubscribe();
    }
    if (this.endEditSubscription && typeof this.endEditSubscription.unsubscribe === 'function') {
      this.endEditSubscription.unsubscribe();
    }
  }

  //#region å¸®å©å­æ®µæ å°

  private lookupMapping(helpData: any, mapFields: any, asClear: boolean = false, spliter: string = ',') {
    if (!mapFields) {
      return;
    }
    // å³é­åæ´æ£æµ
    const appContext = this.viewModel.frameContext.appContext;
    appContext.changeDetectionController.detach();

    const pathArr = this.getBindingPathArray();
    let helpFields = Object.keys(mapFields);
    const primaryInfo = this.getMapFieldsPrimaryKey(mapFields, pathArr);

    let primaryKeys = primaryInfo && primaryInfo.map((item) => item.primaryKey) || [];
    const primaryFields = primaryInfo && primaryInfo.map((item) => item.primaryField) || [];
    // å»é
    if (primaryKeys && primaryKeys.length > 0) {
      primaryKeys = [...new Set(primaryKeys)];
      helpFields = this.sortMapFieldKeys(helpFields, primaryKeys);
    }

    if (!helpData || asClear) {
      helpFields.reverse();
    }
    helpFields.forEach((f: any) => {
      let val: any = '';
      if (helpData) {
        if (helpData instanceof Array) {
          val = helpData.map((h: any) => {
            return this.getValue(f, h);
          }).join(spliter);
        } else {
          val = this.getValue(f, helpData);
        }
      }

      let mappings: any[] = mapFields[f].split(',');
      const headMappings = mappings.filter((p) => primaryFields.includes(p));
      const leftMappings = mappings.filter((p) => !primaryFields.includes(p));
      if (!helpData) {
        mappings = [].concat(leftMappings).concat(headMappings);
      } else {
        mappings = [].concat(headMappings).concat(leftMappings);
      }
      mappings.forEach((ff: any) => {
        if (!helpData) {
          this.viewModel.bindingData.clearValue(pathArr.concat(ff.split('.')), true, true);
        } else {
          this.viewModel.bindingData.setValue(pathArr.concat(ff.split('.')), val, true, true);
        }
      });
    });

    // éæ°æå¼åæ´æ£æµ
    appContext.changeDetectionController.reattach();
  }

  private getValue(f: string, data: any) {
    let val = '';
    if (f.indexOf('.') === -1) {
      val = data[f];
    } else {
      val = f.split('.').reduce((a, b) => {
        return a[b];
      }, data);
    }

    return val;
  }

  private getBindingPathArray(): any[] {
    const path = this.viewModel.bindingPath;
    if (path) {
      return path.split('/').filter((n) => n !== '');
    }
    return [];
  }

  private isNumberValue(field, data) {
    const currentVal = this.getValue(field, data);
    return isNumber(currentVal);
  }

  //#endregion
  /**
   *
   * @param mapFields  æ ¼å¼å½¢å¦ï¼{id: "assoField.assoField", code: "assoField.assoField_Code", name: "assoField.assoField_Name"} æè {id:'vid',code:'code',name:'name'}
   */
  private getMapFieldsPrimaryKey(mapFields: any, bindingPaths: string[]): Array<{ primaryKey: string, primaryField: string; }> {
    if (!mapFields || Object.keys(mapFields).length < 1) {
      return null;
    }
    const results = [];
    // let primaryField = null;
    try {
      const entityTypeInfo: DataTypeInfo = this.viewModel.frameContext.repository.entityTypeInfo;
      Object.keys(mapFields).forEach((key: string) => {
        const mapField = mapFields[key];
        if (mapField && typeof mapField === 'string') {
          const mappings = mapField.split(',').filter((p) => p);
          mappings.forEach((item: string) => {
            let paths = item.split('.');
            if (bindingPaths && bindingPaths.length > 0) {
              paths = bindingPaths.concat(paths);
            }
            const propInfo: DataPropInfo = entityTypeInfo.getPropInfoByPath(paths);
            if (propInfo && propInfo.metadataInfo && propInfo.metadataInfo.primary === true) {
              results.push({
                primaryKey: key,
                primaryField: item
              });
            }
          });
        }
      });
    } catch (e) {
      console.error(e);
    }
    return results;
  }
  private setValue(target: object, paths: string[], value: any) {
    if (target) {
      if (paths.length <= 1) {
        target[paths[0]] = value;
      } else {
        paths.slice(0, -1).reduce((prev, path) => {
          if (!(prev.hasOwnProperty(path) || prev['__proto__'].hasOwnProperty(path))) {
            prev[path] = {};
          }
          return prev[path];
        }, target)[paths[paths.length - 1]] = value;
      }
    }
  }
  private sortMapFieldKeys(keys: string[], primaryKeys: string[]): string[] {
    if (!primaryKeys || primaryKeys.length < 1 || !keys || keys.length < 1) {
      return keys;
    }
    // è¿æ»¤åºéä¸»é®æ å°å­æ®µ
    keys = keys.filter((p) => !primaryKeys.includes(p));
    return [].concat(primaryKeys).concat(keys);
  }
}
